// Field help for the Assistant (REQ-118, SCR-310/311): a topic per refusal code the screens explain
// (`REFUSAL_HELP` in @nexus/ui's assistant model). tests/unit/assistant.test.ts checks that every
// id the library names has a topic here.
import type { HelpTopic } from "../topic";

export const ASSISTANT_TOPICS = {
  "assistant.agentDisabled": {
    title: "The Assistant is turned off",
    body: "The Assistant is switched off for the whole fleet, or not offered for this customer, so no conversation can be opened and nothing runs.",
    example: "With the Assistant off for the fleet, New conversation answers “The Assistant is turned off” on every customer.",
    article: "assistant",
    section: "agent-disabled",
  },
  "assistant.sessionTerminal": {
    title: "This conversation has ended",
    body: "An ended conversation can be read but takes no more messages. Conversations end after 30 minutes idle, after 24 hours, when their budget is spent, or when someone ends them.",
    example: "A message sent to yesterday's conversation is refused; start a new conversation from All conversations.",
    article: "assistant",
    section: "session-terminal",
  },
  "assistant.agentDailyBudgetExhausted": {
    title: "Today's Assistant budget is spent",
    body: "The customer's or the fleet's daily Assistant model budget is used up, so no new turn starts until it resets. The message says when to try again. It is AllCode's spend, never the customer's.",
    example: "With the day's $50 spent on this customer, a new question is refused with “Try again in about 3 hours”.",
    article: "assistant",
    section: "agent-daily-budget-exhausted",
  },
  "assistant.claudeCode": {
    title: "A Claude Code conversation",
    body: "A conversation labelled Claude Code is driven from your own Claude Code, so it has no message box here. Claude Code links to it whenever it proposes a change: approve or reject that change on this page, as on any conversation.",
    example: "Claude Code proposes raising Eng's quota and prints a link; it opens this conversation, where Approve applies the raise.",
    article: "assistant",
    section: "claude-code",
  },
  "assistant.confirmation": {
    title: "Confirming a risky change",
    body: "A risky change asks you to type a word it shows you: the name of what it changes, how many things it touches, or CONFIRM. Approve stays off until every box matches exactly. The Assistant never fills these in for you.",
    example: "Turning the GPT models off for Codex asks you to type “Codex” before Approve turns on.",
    article: "assistant-approvals",
    section: "confirmations",
  },
  "assistant.rejectReason": {
    title: "Why reject it?",
    body: "Say in a sentence why the change is wrong. The Assistant reads it and can propose something else; nothing is changed.",
    example: "“Keep Eng at $300 until the budget review” rejects the raise, and the Assistant answers with what it can do instead.",
    article: "assistant-approvals",
    section: "rejecting",
  },
} satisfies Record<string, HelpTopic>;
